import IconAtomView from 'views/atoms/icon-atom/icon-atom-view';
import LinkAtomView from 'views/atoms/link-atom/link-atom-view';
import ButtonAtomView from 'views/atoms/button-atom/button-atom-view';
import ControlBarButtonAtomView from 'views/atoms/control-bar-button-atom/control-bar-button-atom-view';
import ControlBarMenuAtomView from 'views/atoms/control-bar-menu-atom/control-bar-menu-atom-view';
import LocaleHTMLAtomView from 'views/atoms/locale-html-atom/locale-html-atom-view';
import LocaleHeadingAtomView from 'views/atoms/locale-heading-atom/locale-heading-atom-view';
import TooltipAtomView from 'views/atoms/tooltip-atom/tooltip-atom-view';
import ImageAtomView from 'views/atoms/image-atom/image-atom-view';

export const atoms = {
  IconAtomView,
  LinkAtomView,
  ButtonAtomView,
  ControlBarButtonAtomView,
  ControlBarMenuAtomView,
  LocaleHTMLAtomView,
  LocaleHeadingAtomView,
  TooltipAtomView,
  ImageAtomView,
};

export const ModulesToAtomsMap = {
  'icon-fontawesome': 'IconAtomView',
  'locale-heading': 'LocaleHeadingAtomView',
  'locale-html': 'LocaleHTMLAtomView',
  link: 'LinkAtomView',
  tooltip: 'TooltipAtomView',
  image: 'ImageAtomView',
};
